import { render, staticRenderFns } from "./ActivePlanBox.vue?vue&type=template&id=7e9b64e1&"
import script from "./ActivePlanBox.vue?vue&type=script&lang=js&"
export * from "./ActivePlanBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports